import { useRef, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import useSegment from './useSegment';

export default function useSegmentPageCapture(pageName = '') {
  const params = useParams();
  const location = useLocation();

  const { page } = useSegment();
  const isCapturedRef = useRef(false);

  useEffect(() => {
    if (!isCapturedRef.current) {
      page(pageName, {
        params,
        ...location
      });
      isCapturedRef.current = true;
    }
  }, [page, pageName, params, location]);
}
